<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户ID，外键{user.id}" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID，外键{user.id}" />
      </a-form-model-item>
      <a-form-model-item label="身高,单位cm" prop="height" >
        <a-input v-model="form.height" placeholder="请输入身高,单位cm" />
      </a-form-model-item>
      <a-form-model-item label="体重,单位kg" prop="weight" >
        <a-input v-model="form.weight" placeholder="请输入体重,单位kg" />
      </a-form-model-item>
      <a-form-model-item label="体脂,单位%" prop="bodyFat" >
        <a-input v-model="form.bodyFat" placeholder="请输入体脂,单位%" />
      </a-form-model-item>
      <a-form-model-item label="BMR" prop="bmr" >
        <a-input v-model="form.bmr" placeholder="请输入BMR" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getStature, addStature, updateStature } from '@/api/stature/stature'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        height: null,

        weight: null,

        bodyFat: null,

        bmr: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID，外键{user.id}不能为空', trigger: 'blur' }
        ],
        height: [
          { required: true, message: '身高,单位cm不能为空', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '体重,单位kg不能为空', trigger: 'blur' }
        ],
        bodyFat: [
          { required: true, message: '体脂,单位%不能为空', trigger: 'blur' }
        ],
        bmr: [
          { required: true, message: 'BMR不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        height: null,
        weight: null,
        bodyFat: null,
        bmr: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getStature({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateStature(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addStature(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
